<template>
	<div class="m-drawer" :class="{ open: isOpen }" @click.self="$emit('close')">
		<div class="m-sheet" :class="{ 'm-sheet-product': showProduct }">
			<transition name="fade" mode="out-in">
				<MenuProduct v-if="showProduct" class="sheet-content-product" key="product" :tab="currentTab"
					:section="currentSection" :items="currentCategoryItems" @back="closeProduct"
					@close="$emit('close')" />
				<MenuSec v-else-if="showSec" class="sheet-content" key="sec" :secMenu="secMenu"
					:items="currentInfoItems" @back="closeSec" @close="$emit('close')" />
				<div v-else key="main" class="sheet-content">
					<div class="m-sheet-top">
						<button class="icon-btn" @click="$emit('search')">
							<img src="@/assets/icon/search_black.png" alt="search" />
						</button>
						<button class="icon-btn" @click="$emit('close')">×</button>
					</div>

					<div class="m-tabs">
						<span class="tab"
							:class="{ active: activeTab === 'collection', inactive: activeTab !== 'collection' }"
							@click="setTab('collection')">Collection</span>
						<span class="tab" :class="{ active: activeTab === 'info', inactive: activeTab !== 'info' }"
							@click="setTab('info')">Info</span>
						<span class="tab"
							:class="{ active: activeTab === 'projects', inactive: activeTab !== 'projects' }"
							@click="setTab('projects')">HAHA!</span>
					</div>

					<transition name="fade" mode="out-in">
						<!-- Collection 标签内容 -->
						<div v-if="activeTab === 'collection'" key="collection" class="tab-content">
							<div v-for="block in collectionBlocks" :key="block.title" class="m-section">
								<div class="m-title" @click="goToBy('collection', block.sectionKey)">
									{{ block.title }}
								</div>
							</div>
							<div class="m-view-all" @click="goToAllCollection">VIEW ALL</div>
						</div>

						<!-- Info 标签内容 -->
						<div v-else-if="activeTab === 'info'" key="info" class="tab-content">
							<div v-for="block in infoBlocks" :key="block.title" class="m-section">
								<div class="m-title" @click="openSecMenu(block.sectionKey, block.title)">
									{{ block.title }}
								</div>
							</div>
						</div>

						<!-- Projects 标签内容 -->
						<div v-else key="projects" class="tab-content">
							<div class="m-section">
								<div class="m-title" @click="goToProjects">denHolm United</div>
							</div>
						</div>
					</transition>

					<div class="m-bottom-links">
						<a class="m-link" @click="goToLogin">Login</a>
						<a class="m-link" @click="openSubscribe">Subscribe</a>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { getCategoryList } from '@/api/product'
import { showMessage } from '@/config/message'
import MenuProduct from './MenuProduct.vue'
import MenuSec from './MenuSec.vue'

import aboutImg from '@/assets/_DSC0544 2 3.jpg'
import founderImg from '@/assets/_DSC0544 2 4.jpg'
import contactImg from '@/assets/_DSC0544 2 4.png'

export default {
	name: 'MobileMenu',
	props: { isOpen: { type: Boolean, default: false } },
	components: { MenuProduct, MenuSec },
	data() {
		return {
			activeTab: 'collection',
			showProduct: false,
			showSec: false,
			currentTab: '',
			currentSection: '',
			secMenu: { title: '', thirdTitel: '' },
			collectionBlocks: [],
			collectionMap: {},
			infoBlocks: [
				{ title: 'ABOUT', sectionKey: 'about', items: [] },
				{ title: 'CONTACT', sectionKey: 'contact', items: [] }
			],
			infoMap: {
				about: [{ label: 'About Us', route: 'About', image: aboutImg }, { label: 'Founder', route: 'Founder', image: founderImg }],
				contact: [{ label: 'Contact', route: 'Contact', image: contactImg }]
			},
			defaultCollectionBlocks: [
				{ title: 'TABLES', sectionKey: 'table' },
				{ title: 'SEATINGS', sectionKey: 'seating' },
				{ title: 'ACCESSORIES', sectionKey: 'accessories' }
			],
			defaultCollectionMap: {
				table: [{ label: 'Entry Tables', CategoryID: 1, image: require('@/assets/Group 1-1.png') }, { label: 'Console Tables', CategoryID: 2, image: require('@/assets/Group 1-2.png') }, { label: 'Coffee Table', CategoryID: 3, image: require('@/assets/Group 1-3.png') }, { label: 'Side Table', CategoryID: 4, image: require('@/assets/Group 1-4.png') }],
				seating: [{ label: 'Chair', CategoryID: 5, image: require('@/assets/_DSC0544 2 3.png') }, { label: 'Stool', CategoryID: 6, image: require('@/assets/_DSC0544 2 3-1.png') }],
				accessories: [{ label: 'Planter', CategoryID: 7, image: require('@/assets/_DSC0544 2 4.jpg') }, { label: 'Lighting', CategoryID: 8, image: require('@/assets/_DSC0544 2 3.png') }, { label: 'Mirror', CategoryID: 9, image: require('@/assets/_DSC0544 2 3-1.png') }, { label: 'Hardware', CategoryID: 10, image: require('@/assets/_DSC0544 2 4.jpg') }, { label: 'Decor', CategoryID: 11, image: require('@/assets/_DSC0544 2 3.png') }]
			},
			defaultInfoMap: {
				about: [{ label: 'About Us', route: 'About', image: require('@/assets/_DSC0544 2 3.jpg') }, { label: 'Founder', route: 'Founder', image: require('@/assets/_DSC0544 2 4.jpg') }],
				contact: [{ label: 'Contact', route: 'Contact', image: require('@/assets/_DSC0544 2 4.png') }]
			}
		}
	},
	computed: {
		currentCategoryItems() { return this.collectionMap[this.currentSection] || [] },
		currentInfoItems() { return this.infoMap[this.secMenu.thirdTitel.toLowerCase()] || [] }
	},
	watch: {
		isOpen(val) {
			if (val) {
				this.fetchCollectionData()
			} else {
				this.showProduct = false
				this.showSec = false
				this.currentSection = ''
			}
		}
	},
	created() {
		this.collectionBlocks = this.defaultCollectionBlocks
		this.collectionMap = this.defaultCollectionMap
		this.infoMap = this.defaultInfoMap
	},
	mounted() { if (this.isOpen) this.fetchCollectionData() },
	methods: {
		setTab(tab) { this.activeTab = tab },
		async fetchCollectionData() {
			if (this.collectionBlocks.length === 0) {
				this.collectionBlocks = this.defaultCollectionBlocks
				this.collectionMap = this.defaultCollectionMap
			}
			try {
				const response = await getCategoryList()
				const list = Array.isArray(response) ? response : (response.result || [])
				if (!list.length) return
				const blocks = []
				const map = {}
				list.forEach(block => {
					const title = block.CategoryName
					const sectionKey = this.normalizeKey(title)
					blocks.push({ title, sectionKey })
					const items = (block.Items || []).map(item => ({
						key: this.normalizeKey(item.CategoryName),
						label: item.CategoryName,
						CategoryID: item.CategoryID,
						image: item.CategoryImage
					}))
					map[sectionKey] = items
				})
				this.collectionBlocks = blocks
				this.collectionMap = map
			} catch (error) { console.error('Failed to load collection categories:', error) }
		},
		normalizeKey(str) { return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') },
		goToBy(tab, sectionKey) { this.currentTab = tab; this.currentSection = sectionKey; this.showProduct = true },
		openSecMenu(sectionKey, title) { this.secMenu = { title, thirdTitel: sectionKey }; this.showSec = true },
		closeSec() { this.showSec = false },
		closeProduct() { this.showProduct = false },
		goToAllCollection() { this.$router.push({ name: 'ProductIndex', query: { CategoryID: 0 } }); this.$emit('close') },
		goToProjects() { window.open('https://www.denholm-united.com', '_blank') },
		goToLogin() { this.$router.push('/m/user-info'); this.$emit('close') },
		openSubscribe() { this.$emit('close'); window.dispatchEvent(new CustomEvent('open-email-popup')) }
	}
}
</script>

<style scoped>
.m-drawer {
	position: fixed;
	left: 0; right: 0; bottom: 0; top: 0;
	height: 100vh;
	background: rgba(0, 0, 0, 0);
	z-index: 50;
	pointer-events: none;
	transition: background-color 0.3s ease;
}
.m-drawer.open {
	pointer-events: auto;
}

.m-sheet {
	position: fixed;
	left: 0; right: 0; bottom: 0;
	transform: translateY(100%);
	transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	/* ★ 保持原有高度比例，仅增加安全区 padding */
	height: 80vh;
	max-height: 80vh;
	border-top: 1rem solid #000;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	background: rgba(255, 255, 255, 1);
	/* 底部安全区，不影响原有高度计算 */
	padding-bottom: env(safe-area-inset-bottom, 0px);
	box-sizing: border-box;
}
.open .m-sheet { transform: translateY(0%); }

.m-sheet.m-sheet-product {
	display: flex; flex-direction: column; overflow: hidden; min-height: 0;
}
.sheet-content-product, .sheet-content {
	padding: 0;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.sheet-content { 
  padding: 30rem 29rem;
 }

.tab-content {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
.tab-content::-webkit-scrollbar { display: none; }

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

.m-sheet-top {
	display: flex; justify-content: space-between; align-items: center; margin-bottom: 42rem;
}
.icon-btn {
	background: none; border: none; padding: 0;
	width: 28rem; height: 28rem;
	display: flex; align-items: center; justify-content: center;
	font-size: 20rem; color: #000;
}
.icon-btn img { width: 18rem; height: 18rem; }

.m-tabs {
	display: flex; justify-content: space-between; gap: 10rem;
	align-items: center; padding: 0 0 70rem;
}
.tab {
	font-size: 15rem; font-weight: 400;
	font-family: 'Apercu-Medium', sans-serif !important;
}
.tab.active { color: #000; }
.tab.inactive { color: #bbb; }

.m-section { padding-top: 15rem; font-family: 'Apercu-Medium', sans-serif !important; }
.m-title { font-size: 15rem; font-weight: 500; font-family: 'Apercu-Medium', sans-serif !important; }
.m-view-all { padding: 68rem 0; font-size: 15rem; font-weight: 500; font-family: 'Apercu-Medium', sans-serif !important; }

/* ★ 底部链接：保持原有样式，仅添加安全区域内边距 */
.m-bottom-links {
	padding: 40rem 0 calc(40rem + env(safe-area-inset-bottom, 0px));
	display: grid;
	gap: 2rem;
	margin-top: auto;
}
.m-link {
	color: #000; text-decoration: none;
	font-size: 15rem; font-weight: 400;
	font-family: 'Apercu-Medium', sans-serif !important;
}
</style>